import React from "react";
import Link from "next/link";
import { IconPhone } from "./icon-phone";
import Image from "./image";

export const Product = ({ product }) => {
  return (
    <article className={`grid grid-cols-6 bg-white mb-4`}>
      <div
        className={`col-span-6 lg:col-span-2 flex flex-col items-center justify-center`}
      >
        <Image
          image={product?.attributes?.image}
          alt={product?.attributes?.name}
        />
      </div>
      <div className={`col-span-6 lg:col-span-4 px-6 py-6`}>
        <h4 className={`font-display text-[24px] font-semibold`}>
          {product?.attributes?.name}
        </h4>
        {product?.attributes?.description && (
          <div className={`mt-4`}>{product?.attributes?.description}</div>
        )}
        {product?.attributes?.details?.length > 0 && (
          <table className={`table-fixed mt-4 w-3/4`}>
            <thead className={`leading-none`}>
              <tr>
                <th className={`text-left`}>Part Number</th>
                <th className={`text-left`}>Size</th>
                <th className={`text-left`}>Minimum Break Strength</th>
              </tr>
            </thead>
            <tbody>
              {product?.attributes?.details?.map((detail, key) => {
                return (
                  <tr key={key}>
                    <td>{detail?.part_number}</td>
                    <td>{detail?.size}</td>
                    <td>{detail?.minimum_break_strength}</td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        )}
        <div className={`mt-4 border-t py-6 pb-2 flex flex-row items-center`}>
          <div className={`font-display text-gray-700`}>
            <div className={`flex flex-row items-center space-x-4`}>
              <div>
                <IconPhone fill={"gray"} />
              </div>{" "}
              <div>Call for pricing</div>
            </div>
          </div>
        </div>
      </div>
    </article>
  );
};
